import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
//import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { logAndNotifyError } from "../logger";
import { IModuleByggnadsdata, IModuleVärmePrimärPump, Värmekällor } from "../../types/ModuleDatas";
import { nameof } from "../../components/Global/Utils";
import { formatStringFn } from "../common";
import { IJ13_BFData, IJ3_FTX_FT_BFData } from "../../types/BFDatas";

//todo -> make class?!
export const bfv_J13 = (): IBFModule => {
  const bfName = BFLType.BFV_J13;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData): IBFResult => {
    //const moduleData: IModuleVattenburetSekundärsystem = module.data;

    let funktionsKontroller: IKontrollResultRow[] = [];
    let driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
    let dbg: any = {};
    let error = "";

    const bH = bflHelper.bflHelper();
    try {
      const moduleData: IModuleVärmePrimärPump = module.data;

      const modPreviousFjärrVärmePump = roundHandler.getLastFinishedRound()?.data.modules.find((m) => m.id === module.id);
      const modPreviousFjärrVärmePumpData = modPreviousFjärrVärmePump?.data as IModuleVärmePrimärPump | undefined;

      const byggnadsDataData: IModuleByggnadsdata | undefined = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata)?.data;

      const c11_ronderingÅrligVärmeProd = moduleData.årligVärmeproduktion || modPreviousFjärrVärmePumpData?.årligVärmeproduktion || 0;
      const ronderingUppgiftEnergistatistik = moduleData.uppgiftEnergistatistik || "";
      const ronderingAckumuleradeDrifttimmar = moduleData.ackumuleradeDrifttimmar || 0;
      const ronderingAckumuleradeTimmarMedElTillskott = moduleData.ackumuleradeTimmar || 0;
      const rondHarUppdateratDrifttimmar = moduleData.harUppdateratDrifttimmar || "Nej";

      let c12_årligElAnvändning = moduleData.årligElAnvändning || modPreviousFjärrVärmePumpData?.årligElAnvändning || 0;
      c12_årligElAnvändning = c12_årligElAnvändning < 1 ? 1 : c12_årligElAnvändning;

      const c13_beräknadVärmeFaktor = c12_årligElAnvändning > 0 ? c11_ronderingÅrligVärmeProd / c12_årligElAnvändning : 0;
      //uppdateratEnergiStatistik=IF('Grunddata IN'!G38='Grunddata IN'!K38;"Ja";"Nej")
      //'Grunddata IN'!K38:   === Uppdaterad energistatistik
      const textUppdaterad = globalData.Värme.VärmepumpEnergistatistik.find((r) => r.Id === "Uppdaterad")?.VärmepumpEnergistatistik;
      const c14Ja_isUppdateratEnergiStatistik = ronderingUppgiftEnergistatistik === textUppdaterad;

      //=IF('Grunddata IN'!G41="";"Nej";'Grunddata IN'!G41)
      const uppdateratUppgiftOmDriftTimmarVärmepump = rondHarUppdateratDrifttimmar === "Ja";

      //$C$17 : =IF(OR(rondring312UppgiftEnergiStat='Grunddata IN'!$K$38;rond312AckDriftTimmarPump+Rond312AckTimMedElTillskott<0,1);10;rond312AckDriftTimmarPump)
      const ackumuleradeDriftTimmar =
        c14Ja_isUppdateratEnergiStatistik || ronderingAckumuleradeDrifttimmar + ronderingAckumuleradeTimmarMedElTillskott < 0.1 ? 10 : ronderingAckumuleradeDrifttimmar;

      // $C$18 : =IF(OR(rondring312UppgiftEnergiStat='Grunddata IN'!$K$38;rond312AckDriftTimmarPump+Rond312AckTimMedElTillskott<0,1);1;Rond312AckTimMedElTillskott)
      const ackumuleradeTimmarMedElTillskott =
        c14Ja_isUppdateratEnergiStatistik || ronderingAckumuleradeDrifttimmar + ronderingAckumuleradeTimmarMedElTillskott < 0.1 ? 10 : ronderingAckumuleradeTimmarMedElTillskott;
      //C19 : =$C$17/($C$18+$C$17)
      const beräknadEnergitäckningsgrad =
        ackumuleradeDriftTimmar + ackumuleradeTimmarMedElTillskott !== 0 ? ackumuleradeDriftTimmar / (ackumuleradeDriftTimmar + ackumuleradeTimmarMedElTillskott) : 0;
      //C20 : =IF(rond312UppdateratAckDriftTimmarJaNej="";"Nej";rond312UppdateratAckDriftTimmarJaNej) => rondHarUppdateratDrifttimmar

      dbg["beräknad Energitäckningsgrad"] = {
        ackumuleradeDriftTimmar,
        ackumuleradeTimmarMedElTillskott,
      };

      const valtVärmepumpSystem = moduleData.systemTyp;
      const energiKällaDataRow = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === valtVärmepumpSystem);
      //*****************Gränsvärden******************* */

      const normalCOP_frånluft = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === Värmekällor.Frånluftsvärmepump)?.COP;
      const normalCOP_frånluftMedInverterstyrning = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === Värmekällor.FrånluftsvärmepumpMedInverterstyrning)?.COP;
      const normalCOP_markvärmePump = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === Värmekällor.Markvärmepump)?.COP;
      const normalCOP_värmepumpLuftVatten = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === Värmekällor.VärmepumpLuftVatten)?.COP;

      const gränsvärdeCOPok_frånluft = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === Värmekällor.Frånluftsvärmepump)?.BFV_J13_GränsvärdeCOP;
      const gränsvärdeCOPok_frånluftMedInverterstyrning = globalData.Byggnadsdata.Värmekälla.find(
        (r) => r.Värmekälla === Värmekällor.FrånluftsvärmepumpMedInverterstyrning
      )?.BFV_J13_GränsvärdeCOP;
      const gränsvärdeCOPok_markvärmePump = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === Värmekällor.Markvärmepump)?.BFV_J13_GränsvärdeCOP;
      const gränsvärdeCOPok_värmepumpLuftVatten = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === Värmekällor.VärmepumpLuftVatten)?.BFV_J13_GränsvärdeCOP;

      const normalEnergitäckningsgrad = bimHandler.BIM_Vägledande_Energitäckningsgrad_Värmekälla;
      const gränsvärde_energitäckningsgrad_värmepump = normalEnergitäckningsgrad * 0.8;

      dbg["gränsvärden"] = { gränsvärdeCOPok_frånluft, gränsvärdeCOPok_frånluftMedInverterstyrning, gränsvärdeCOPok_markvärmePump, gränsvärdeCOPok_värmepumpLuftVatten };

      //******************Avvikelser *************************** */
      //       avvikelseSPFCOP_frånluft ==IF(AND(uppdateratEnergiStatistikJaNej="Ja";beräknadVärmeFaktor<gränsvärdeCOPok_frånluft);(C45-C46)/C45;0)
      // C45 : =normalCOP_frånluft
      // C46 : =beräknadVärmeFaktor
      const avvikelseSPFCOP_frånluft =
        c14Ja_isUppdateratEnergiStatistik && normalCOP_frånluft && gränsvärdeCOPok_frånluft && c13_beräknadVärmeFaktor < gränsvärdeCOPok_frånluft
          ? (normalCOP_frånluft - c13_beräknadVärmeFaktor) / normalCOP_frånluft
          : 0;
      const avvikelseSPFCOP_frånluftMedInverterstyrning =
        c14Ja_isUppdateratEnergiStatistik &&
        normalCOP_frånluftMedInverterstyrning &&
        gränsvärdeCOPok_frånluftMedInverterstyrning &&
        c13_beräknadVärmeFaktor < gränsvärdeCOPok_frånluftMedInverterstyrning
          ? (normalCOP_frånluftMedInverterstyrning - c13_beräknadVärmeFaktor) / normalCOP_frånluftMedInverterstyrning
          : 0;
      const avvikelseSPFCOP_markvärmepump =
        c14Ja_isUppdateratEnergiStatistik && normalCOP_markvärmePump && gränsvärdeCOPok_markvärmePump && c13_beräknadVärmeFaktor < gränsvärdeCOPok_markvärmePump
          ? (normalCOP_markvärmePump - c13_beräknadVärmeFaktor) / normalCOP_markvärmePump
          : 0;
      const avvikelseSPFCOP_värmepumpLuftVatten =
        c14Ja_isUppdateratEnergiStatistik && normalCOP_värmepumpLuftVatten && gränsvärdeCOPok_värmepumpLuftVatten && c13_beräknadVärmeFaktor < gränsvärdeCOPok_värmepumpLuftVatten
          ? (normalCOP_värmepumpLuftVatten - c13_beräknadVärmeFaktor) / normalCOP_värmepumpLuftVatten
          : 0;

      //Avvikelse energitäckningsgrad är oberoende av valt system... !
      //avvikelseEnergitäckningsgrad_frånluft=IF(AND(uppdateratUppgiftOmDriftTimmarVärmepump="Ja";beräknadEnergitäckningsgrad<gränsvärdeEnergitäckningsgrad_värmepump);(normalEnergitäckningsgrad-beräknadEnergitäckningsgrad)/normalEnergitäckningsgrad;0)
      const avvikelseEnergitäckningsgrad_frånluft =
        uppdateratUppgiftOmDriftTimmarVärmepump && beräknadEnergitäckningsgrad < gränsvärde_energitäckningsgrad_värmepump
          ? (normalEnergitäckningsgrad - beräknadEnergitäckningsgrad) / normalEnergitäckningsgrad
          : 0;
      //avvikelseEnergitäckningsgrad_frånluftMedInverterstyrning==IF(AND(uppdateratUppgiftOmDriftTimmarVärmepump="Ja";beräknadEnergitäckningsgrad<gränsvärdeEnergitäckningsgrad_värmepump);(C57-C58)/C57;0)
      const avvikelseEnergitäckningsgrad_frånluftMedInverterstyrning = avvikelseEnergitäckningsgrad_frånluft;
      // uppdateratUppgiftOmDriftTimmarVärmepump && beräknadEnergitäckningsgrad < gränsvärde_energitäckningsgrad_värmepump
      //   ? (normalEnergitäckningsgrad - beräknadEnergitäckningsgrad) / normalEnergitäckningsgrad
      //   : 0;

      const avvikelseEnergitäckningsgrad_markvärmepump = avvikelseEnergitäckningsgrad_frånluft;
      // uppdateratUppgiftOmDriftTimmarVärmepump && beräknadEnergitäckningsgrad < gränsvärde_energitäckningsgrad_värmepump
      //   ? (normalEnergitäckningsgrad - beräknadEnergitäckningsgrad) / normalEnergitäckningsgrad
      //   : 0;

      const avvikelseEnergitäckningsgrad_värmepumpLuftVatten = avvikelseEnergitäckningsgrad_frånluft;
      // uppdateratUppgiftOmDriftTimmarVärmepump && beräknadEnergitäckningsgrad < gränsvärde_energitäckningsgrad_värmepump
      //   ? (normalEnergitäckningsgrad - beräknadEnergitäckningsgrad) / normalEnergitäckningsgrad
      //   : 0;

      //*****************Kontroll värmefaktor******************* */

      const årligAnvTappVarmvatten = moduleData.harProduktionVatten === "Ja" && bimHandler.G19_BruttoEnergiTappvatten ? bimHandler.G19_BruttoEnergiTappvatten : 0;
      const årligenergiTransmission = moduleData.harProduktionVärme === "Ja" && bimHandler.G15_BruttoAnvändningTransmission() ? bimHandler.G15_BruttoAnvändningTransmission() : 0;
      const årligEnergiVentilation = bimHandler.G17_BruttoEnergiVentilation();
      let värmepumpensSystemAndel =
        moduleData.årligElAnvändning && byggnadsDataData?.årligEnergiFörbrukning ? moduleData.årligElAnvändning / byggnadsDataData.årligEnergiFörbrukning : 0;
      if (värmepumpensSystemAndel > 1) värmepumpensSystemAndel = 1;

      const vägledandeVerkningsgradVärmePump = energiKällaDataRow?.COP as number;

      //c31=IF(AND(valtVärmepumpssystem='Grunddata IN'!K12;uppdateratEnergiStatistikJaNej="Ja");avvikelseSPFCOP_frånluft*(årligAnvTappVarmvatten+årligenergiTransmission+årligEnergiVentilation)*värmepumpensSystemAndel/vägledandeVerkningsgradVärmePump;0)
      const överkonsumtion_frånluft_pgaVärmefaktor =
        valtVärmepumpSystem === "Frånluftsvärmepump" && c14Ja_isUppdateratEnergiStatistik
          ? (avvikelseSPFCOP_frånluft * (årligAnvTappVarmvatten + årligenergiTransmission + årligEnergiVentilation) * värmepumpensSystemAndel) / vägledandeVerkningsgradVärmePump
          : 0;
      //c32 =IF(AND(valtVärmepumpssystem='Grunddata IN'!K13;uppdateratEnergiStatistikJaNej="Ja");avvikelseSPFCOP_frånluftMedInverterstyrning*(årligAnvTappVarmvatten+årligenergiTransmission)*värmepumpensSystemAndel/vägledandeVerkningsgradVärmePump;0)
      const överkonsumtion_frånluftMedInverterstyrning_pgaVärmefaktor =
        valtVärmepumpSystem === "Frånluftsvärmepump med inverterstyrning" && c14Ja_isUppdateratEnergiStatistik
          ? (avvikelseSPFCOP_frånluftMedInverterstyrning * (årligAnvTappVarmvatten + årligenergiTransmission) * värmepumpensSystemAndel) / vägledandeVerkningsgradVärmePump
          : 0;
      //c33 =IF(AND(valtVärmepumpssystem='Grunddata IN'!K11;uppdateratEnergiStatistikJaNej="Ja");avvikelseSPFCOP_markvärmepump*(årligAnvTappVarmvatten+årligenergiTransmission)*värmepumpensSystemAndel/vägledandeVerkningsgradVärmePump;0)
      const överkonsumtion_markvärmepump_pgaVärmefaktor =
        valtVärmepumpSystem === "Markvärmepump" && c14Ja_isUppdateratEnergiStatistik
          ? (avvikelseSPFCOP_markvärmepump * (årligAnvTappVarmvatten + årligenergiTransmission) * värmepumpensSystemAndel) / vägledandeVerkningsgradVärmePump
          : 0;
      //c34 =IF(AND(valtVärmepumpssystem='Grunddata IN'!K11;uppdateratEnergiStatistikJaNej="Ja");avvikelseSPFCOP_markvärmepump*(årligAnvTappVarmvatten+årligenergiTransmission)*värmepumpensSystemAndel/vägledandeVerkningsgradVärmePump;0)
      const överkonsumtion_värmepumpLuftVatten_pgaVärmefaktor =
        valtVärmepumpSystem === "Värmepump Luft / Vatten" && c14Ja_isUppdateratEnergiStatistik
          ? (avvikelseSPFCOP_värmepumpLuftVatten * (årligAnvTappVarmvatten + årligenergiTransmission) * värmepumpensSystemAndel) / vägledandeVerkningsgradVärmePump
          : 0;
      //***************** */
      //c35=IF(valtVärmepumpssystem='Grunddata IN'!K12;avvikelseEnergitäckningsgrad_frånluft*(årligAnvTappVarmvatten+årligenergiTransmission)*värmepumpensSystemAndel/vägledandeVerkningsgradVärmePump;0)
      const överkonsumtion_frånluft_pgaEnergitäckning =
        valtVärmepumpSystem === "Frånluftsvärmepump" && !c14Ja_isUppdateratEnergiStatistik
          ? (avvikelseEnergitäckningsgrad_frånluft * (årligAnvTappVarmvatten + årligenergiTransmission) * värmepumpensSystemAndel) / vägledandeVerkningsgradVärmePump
          : 0;
      //c36==IF(valtVärmepumpssystem='Grunddata IN'!K13;avvikelseEnergitäckningsgrad_frånluftMedInverterstyrning*(årligAnvTappVarmvatten+årligenergiTransmission)*värmepumpensSystemAndel/vägledandeVerkningsgradVärmePump;0)
      const överkonsumtion_frånluftMedInverterstyrning_pgaEnergitäckning =
        valtVärmepumpSystem === "Frånluftsvärmepump med inverterstyrning" && !c14Ja_isUppdateratEnergiStatistik
          ? (avvikelseEnergitäckningsgrad_frånluftMedInverterstyrning * (årligAnvTappVarmvatten + årligenergiTransmission) * värmepumpensSystemAndel) /
            vägledandeVerkningsgradVärmePump
          : 0;
      //c37==IF(valtVärmepumpssystem='Grunddata IN'!K14;avvikelseEnergitäckningsgrad_frånluftMedInverterstyrning*(årligAnvTappVarmvatten+årligenergiTransmission)*värmepumpensSystemAndel/vägledandeVerkningsgradVärmePump;0)
      const överkonsumtion_markvärmepump_pgaEnergitäckning =
        valtVärmepumpSystem === "Markvärmepump" && !c14Ja_isUppdateratEnergiStatistik
          ? (avvikelseEnergitäckningsgrad_markvärmepump * (årligAnvTappVarmvatten + årligenergiTransmission) * värmepumpensSystemAndel) / vägledandeVerkningsgradVärmePump
          : 0;
      //c38==IF(valtVärmepumpssystem='Grunddata IN'!K15;avvikelseEnergitäckningsgrad_frånluftMedInverterstyrning*(årligAnvTappVarmvatten+årligenergiTransmission)*värmepumpensSystemAndel/vägledandeVerkningsgradVärmePump;0)
      const överkonsumtion_värmepumpLuftVatten_pgaEnergitäckning =
        valtVärmepumpSystem === "Värmepump Luft / Vatten" && !c14Ja_isUppdateratEnergiStatistik
          ? (avvikelseEnergitäckningsgrad_värmepumpLuftVatten * (årligAnvTappVarmvatten + årligenergiTransmission) * värmepumpensSystemAndel) / vägledandeVerkningsgradVärmePump
          : 0;

      const maxC31_C38 = Math.max(
        överkonsumtion_frånluft_pgaVärmefaktor,
        överkonsumtion_frånluftMedInverterstyrning_pgaVärmefaktor,
        överkonsumtion_markvärmepump_pgaVärmefaktor,
        överkonsumtion_värmepumpLuftVatten_pgaVärmefaktor,
        överkonsumtion_frånluft_pgaEnergitäckning,
        överkonsumtion_frånluftMedInverterstyrning_pgaEnergitäckning,
        överkonsumtion_markvärmepump_pgaEnergitäckning,
        överkonsumtion_värmepumpLuftVatten_pgaEnergitäckning
      );

      const harÖverkonsumtion = maxC31_C38 > 0 ? true : false;
      const harUppdateratIndata = uppdateratUppgiftOmDriftTimmarVärmepump || c14Ja_isUppdateratEnergiStatistik;
      const harÖverkonsumtionSAMTharUppdateratIndata = harÖverkonsumtion && harUppdateratIndata;
      const harUppdateratEnergistatistikELLERDrifttimmarvärmepump = c14Ja_isUppdateratEnergiStatistik || uppdateratUppgiftOmDriftTimmarVärmepump;

      if (harUppdateratEnergistatistikELLERDrifttimmarvärmepump) {
        const lastUpdated = new Date(module.lastUpdated || new Date());
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 13, undefined, "", { formatFn: (varName) => lastUpdated.toLocaleDateString("sv-SE") }));
        //TODO! Add formatFn to options in getFunktionsKontroll
        // funktionsKontroller.push({
        //   index: 13,
        //   kWhs: undefined,
        //   energiSlag: "",
        //   message: formatStringFn(globalData.Funktionskontroller.mapFunktionskontroller.BFVJ13_FKText13.Text, (varName) => lastUpdated.toLocaleDateString("sv-SE")), // "Driftdata uppdaterad: " + new Date().toLocaleDateString("sv-SE"),
        // });
      }
      if (c14Ja_isUppdateratEnergiStatistik) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, undefined, "", { formatFn: (varName) => c13_beräknadVärmeFaktor.toFixed(1) }));
        // funktionsKontroller.push({
        //   index: 1,
        //   kWhs: undefined,
        //   energiSlag: "",
        //   message: formatStringFn(globalData.Funktionskontroller.mapFunktionskontroller.BFVJ13_FKText1.Text, (varName) => c13_beräknadVärmeFaktor.toFixed(1)), // "Beräknad värmefaktor (η): " + c13_beräknadVärmeFaktor.toFixed(1),
        // });
      } else {
        if (uppdateratUppgiftOmDriftTimmarVärmepump) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 2, undefined, "", { formatFn: (varName) => (beräknadEnergitäckningsgrad * 100).toFixed(0) + "%" }));
          // funktionsKontroller.push({
          //   index: 2,
          //   kWhs: undefined,
          //   energiSlag: "",
          //   message: formatStringFn(globalData.Funktionskontroller.mapFunktionskontroller.BFVJ13_FKText2.Text, (varName) => (beräknadEnergitäckningsgrad * 100).toFixed(0)), // "Beräknad energitäckningsgrad (η%): " + (beräknadEnergitäckningsgrad * 100).toFixed(0) + "%",
          // });
        }
      }

      // const funktionsKontroll1 = {
      //   index: 12,
      //   kWhs: undefined as number | undefined,
      //   energiSlag: "",
      //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFVJ13_FKText12b.Text, // "Värmepumpens värmefaktor är kontrollerad utan anmärkning",
      // };
      // if (c14Ja_isUppdateratEnergiStatistik) funktionsKontroll1.message = globalData.Funktionskontroller.mapFunktionskontroller.BFVJ13_FKText12a.Text;

      // funktionsKontroller.push(funktionsKontroll1);

      // if (harUppdateratEnergistatistikELLERDrifttimmarvärmepump && maxC31_C38 < 0.1) {
      //   if (c14Ja_isUppdateratEnergiStatistik) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, "12a", undefined, ""));
      //   else funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, "12b", undefined, ""));
      // }

      //=IF(harÖverkonsumtionSAMTharUppdateratIndata=1;MAX(C31:C38);"")
      if (harÖverkonsumtionSAMTharUppdateratIndata) {
        const kWhs = maxC31_C38;
        const energiSlag = "El";

        if (
          maxC31_C38 === överkonsumtion_frånluft_pgaEnergitäckning ||
          maxC31_C38 === överkonsumtion_frånluftMedInverterstyrning_pgaEnergitäckning ||
          maxC31_C38 === överkonsumtion_markvärmepump_pgaEnergitäckning ||
          maxC31_C38 === överkonsumtion_värmepumpLuftVatten_pgaEnergitäckning
        ) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 7, kWhs, energiSlag));
          // funktionsKontroll1.index = 7;
          // funktionsKontroll1.message = globalData.Funktionskontroller.mapFunktionskontroller.BFVJ13_FKText7; //"Överkonsumtion EL på grund av låg energitäckningsgrad (kWh).";
        } else {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, kWhs, energiSlag));
          // funktionsKontroll1.index = 3;
          // funktionsKontroll1.message = globalData.Funktionskontroller.mapFunktionskontroller.BFVJ13_FKText3; //"Överkonsumtion EL på grund av låg värmefaktor (kWh)";
        }
      } else if (!uppdateratUppgiftOmDriftTimmarVärmepump && !c14Ja_isUppdateratEnergiStatistik) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 11, undefined, ""));
        // funktionsKontroll1.message = globalData.Funktionskontroller.mapFunktionskontroller.BFVJ13_FKText11; //"Ingen uppdaterad driftdata till funktionskontroll";
        // funktionsKontroll1.index = 11;
      } else {
        const fk12Variant = c14Ja_isUppdateratEnergiStatistik ? "a" : "b";
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 12, undefined, "", { variant: fk12Variant }));
      }

      return {
        bfName: BFLType.BFV_J13,
        funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
        driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
        note: "",
        debug: dbg,
      };
    } catch (ex: any) {
      logAndNotifyError(ex);
      return {
        bfName: BFLType.BFV_J13,
        funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
        driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
        note: "",
        error,
        debug: dbg,
      };
    }
  };

  return { bfName, getResult };
};

const dflt = { bfv_J13 };

export default dflt;
